export default "__VITE_ASSET__BfTi9OS9__"